import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "@template-name/trpc-types";

export const trpc = createTRPCReact<AppRouter>();
